// extracted by mini-css-extract-plugin
module.exports = {"container":"MovieList_container__bw71x"};